import { jsx as _jsx } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box, Typography } from "@mui/material";
export function ViewerHelpTitle() {
    return (_jsx(Box, Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }, { children: _jsx(Box, { children: _jsx(Typography, Object.assign({ variant: "h2", display: "inline", sx: { fontSize: { xs: "2.7rem", sm: "3.75rem" } } }, { children: "PlayMolecule.AI" })) }) })));
}
